
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-607d14fc&scoped=true!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Home.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/home.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-607d14fc!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/home.pug"),
  /* scopeId */
  "data-v-607d14fc",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Home.vue
// module id = 1314
// module chunks = 1